import React, { memo } from 'react';
export const BonusSection = memo(function BonusSection() {
  const bonuses = [{
    id: 1,
    icon: '⚡',
    title: 'Kit de Enfoque Inmediato (30 Días)',
    subtitle: 'El que no puede arrancar, con esto no tiene excusa.',
    desc: 'El ritual de 3 minutos + selector de audio + scripts de arranque + plantillas de bloque para entrar en foco inmediatamente, sin fuerza de voluntad. Un bloque de 25 minutos hoy vale más que un mes de planificación.',
    value: '$9.900'
  }, {
    id: 2,
    icon: '📵',
    title: 'Modo Antialgoritmo (30 Días)',
    subtitle: 'Corta la dependencia digital desde el primer día.',
    desc: 'El sistema de límites, fricción y bloqueo para recuperar horas reales cada semana. Configuración paso a paso para iPhone y Android. Ventanas de redes, protocolos de cama, baño y mañana incluidos.',
    value: '$6.900'
  }, {
    id: 3,
    icon: '🌙',
    title: 'Apagado Mental (30 Días)',
    subtitle: 'Cerrá el día con la cabeza liviana y despertá con energía.',
    desc: 'El protocolo nocturno de 7 minutos para vaciar la cabeza, procesar los pendientes y dormir sin el nudo en el estómago. Plantillas de Parking Lot + scripts de cierre + tracker de sueño incluidos.',
    value: '$5.900'
  }, {
    id: 4,
    icon: '📊',
    title: 'Tablero de Control (90 Días)',
    subtitle: 'Lo que no medís, vuelve al caos. Este tablero lo evita.',
    desc: 'El sistema de seguimiento diario, semanal y mensual para medir progreso real, detectar erosión antes de que sea crítica y activar el protocolo anti-recaída cuando el sistema necesita reiniciarse.',
    value: '$7.900'
  }];
  const infiniteBonuses = [...bonuses, ...bonuses, ...bonuses];
  return <section className="py-16 bg-white border-t border-gray-200 overflow-hidden" data-id="element-14">

      {/* ✅ Keyframe de scroll definido inline */}
      <style data-id="element-15">{`
        @keyframes scrollLeft {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
        .animate-scroll-left {
          animation: scrollLeft 25s linear infinite;
          width: max-content;
        }
        .animate-scroll-left:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="max-w-5xl mx-auto px-4" data-id="element-16">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-17">
          <div className="inline-block bg-yellow-50 text-yellow-600 px-5 py-1.5 rounded-full font-black text-[11px] uppercase tracking-widest mb-4 border border-yellow-200" data-id="element-18">
            🎁 BONOS EXCLUSIVOS
          </div>
          <h2 className="text-[24px] md:text-4xl font-black text-gray-900 mb-4 leading-tight max-w-3xl mx-auto" data-id="element-19">
            Con tu Megapack recibís{' '}
            <span className="text-yellow-500" data-id="element-20">
              4 herramientas que activan el sistema desde el día uno:
            </span>
          </h2>
        </div>
      </div>

      {/* Carrusel Infinito */}
      <div className="relative w-full overflow-hidden" data-id="element-21">
        {/* Gradientes laterales */}
        <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-22" />
        <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-23" />

        {/* Track */}
        <div className="animate-scroll-left flex gap-5 py-4 px-4" data-id="element-24">
          {infiniteBonuses.map((bono, index) => <div key={index} className="flex-shrink-0 w-[280px] md:w-[320px] bg-gray-50 rounded-2xl border border-yellow-200 p-6 shadow-md flex flex-col relative overflow-hidden" data-id="element-25">
              {/* Ribbon */}
              <div className="absolute top-0 right-0 bg-yellow-500 text-white text-[10px] font-black uppercase tracking-widest px-4 py-1 rounded-bl-lg" data-id="element-26">
                Bono #{bono.id}
              </div>

              {/* Header */}
              <div className="mb-4 pr-16" data-id="element-27">
                <div className="flex items-center gap-3 mb-2" data-id="element-28">
                  <span className="text-3xl" data-id="element-29">{bono.icon}</span>
                  <h3 className="text-[16px] font-black text-gray-900 leading-tight" data-id="element-30">
                    {bono.title}
                  </h3>
                </div>
                <p className="text-yellow-500 font-bold text-[12px] leading-snug mt-2" data-id="element-31">
                  "{bono.subtitle}"
                </p>
              </div>

              {/* Desc */}
              <p className="text-gray-600 text-[12px] leading-relaxed mb-5 flex-1" data-id="element-32">
                {bono.desc}
              </p>

              {/* Valor */}
              <div className="flex items-center justify-between bg-white p-3 rounded-xl border border-gray-200 mt-auto" data-id="element-33">
                <span className="text-gray-500 text-[11px] font-bold uppercase tracking-wider" data-id="element-34">
                  Valor Real: <span className="line-through" data-id="element-35">{bono.value}</span>
                </span>
                <span className="text-green-600 font-black text-[12px] uppercase tracking-wider" data-id="element-36">
                  INCLUIDO
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
});